var _rect, _path, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropose5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 34,
    fill: "#292929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7044 17.3298H34.0593C34.0593 17.3298 34.0593 25.9249 40.4143 25.9249C46.7692 25.9249 46.7692 17.3298 46.7692 17.3298H53.1242M53.1242 37.385V61.4511C53.1242 61.907 52.9903 62.3442 52.7519 62.6666C52.5136 62.989 52.1903 63.1701 51.8532 63.1701H28.9754C28.6383 63.1701 28.315 62.989 28.0766 62.6666C27.8383 62.3442 27.7044 61.907 27.7044 61.4511V37.385M53.1242 17.3298L62.5359 22.421C62.8488 22.5904 63.0991 22.9211 63.2318 23.3402C63.3645 23.7592 63.3687 24.2324 63.2434 24.6557L59.799 36.3048C59.7046 36.6237 59.5418 36.897 59.3315 37.0895C59.1212 37.282 58.873 37.3849 58.6191 37.385H53.1242M27.7044 17.3298L18.2927 22.421C17.9798 22.5904 17.7294 22.9211 17.5968 23.3402C17.4641 23.7592 17.4599 24.2324 17.5852 24.6557L21.0296 36.3048C21.1239 36.6237 21.2868 36.897 21.4971 37.0895C21.7074 37.282 21.9555 37.3849 22.2095 37.385H27.7044",
    stroke: "url(#paint0_linear_3061_17662)",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 8,
    r: 8,
    fill: "#D50101"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3061_17662",
    x1: 40.4143,
    y1: 17.3298,
    x2: 40.4143,
    y2: 63.1701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F42222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59331"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropose5);
export default __webpack_public_path__ + "static/media/propose5.21bc8b953ee19e137818602125e2db17.svg";
export { ForwardRef as ReactComponent };